import styles from "./Dividend.module.scss";
import { FC } from "react";
import VersusBar from "@/components/versus-bar/VersusBar";
import { withStockStamp } from "@/components/stock-stamp-hoc/StockStampHOC";
import { classNames, formatDate } from "@/lib/utils";
import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";

interface PropsTypes {
    pointValue: number | string;
    allValues: number[];
    exdate: string;
    overviewPage?: boolean;
    mobile?: boolean;
}

const Dividend: FC<PropsTypes> = ({ pointValue, allValues, exdate, overviewPage, mobile }) => {
    // A visitor's payload has scrambled strings in these fields ("srsgrotras"), a stock with no dividend "N/A"
    // or nothing at all, so neither is known to be a date or a number here.
    const parsedExDate = exdate && exdate !== "N/A" ? dayjs(exdate) : undefined;
    const exDate = parsedExDate?.isValid() ? parsedExDate : undefined;
    const value = typeof pointValue === "string" ? pointValue.split("%")[0] : pointValue;
    const yieldKnown = value != null && String(value).trim() !== "" && Number.isFinite(Number(value));
    return (
        <div className={classNames(styles.Dividend, styles[overviewPage && "overview-page"])}>
            <Typography variant={mobile ? "h2" : "moduleContentTitle"} className={!overviewPage ? styles.value : null}>
                {yieldKnown ? `${Number(value).toFixed(2)}%` : "N/A"}
            </Typography>
            <VersusBar title="vs Industry" data={allValues} value={Number(value)} bigFont={overviewPage} />
            <Box className={styles["bottom-text"]} sx={overviewPage && { display: "flex", flexDirection: "column", justifyContent: "space-around" }}>
                <Typography variant="body2">Ex Date</Typography>
                <Typography variant="body2" sx={overviewPage && { fontSize: "12px", "@media screen and (min-width: 1280px)": { fontSize: "9px" } }} className="positive">
                    {exDate !== undefined ? formatDate(exDate) : "N/A"}
                </Typography>
            </Box>
        </div>
    );
};

export default withStockStamp(Dividend, "pointValue", { title: "Div (12M FWD)", align: "center" }, "Dividend");
